// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__ExUIV","label":"Section_label__3IxHq","contentWrap":"Section_contentWrap__1pUBx","footer":"Section_footer__WHtZS","footerInner":"Section_footerInner__fHdrC"};